import store from '@/store/store';
import { formatDateString } from './FormatService';
import { INPUT_TYPES, POLICY_FIELDS } from './FieldService';
import { CmsField, DigitalAcceptCmsPage, Payment, Policy } from '@/types/types';

const ignoreFieldsInUpdateInsuranceObject: string[] = [POLICY_FIELDS.payment_frequency, 
	POLICY_FIELDS.payment_method, 
	POLICY_FIELDS.cover_start_date, 
	POLICY_FIELDS.account,
	POLICY_FIELDS.reg_no,
	POLICY_FIELDS.previous_company_id, 
	POLICY_FIELDS.previous_policy_id, 
	POLICY_FIELDS.termination_option];

export const createDigitalAcceptSubmitRequest = () => {

	// const Payment = createPayment();

	const policies = createPolicies();

	const digitalAcceptResponse: DigitalAcceptCmsPage = {
		policies,
		// party: {
		// 	payment: Payment,
		// },
	};
	return digitalAcceptResponse;
};

const createPolicies = (): Array<Policy> => {
	const policies: Array<Policy> = [];

	const policyIds = store.state.ProposalContext.originalRequest.policies.map((policy) => policy.id);
	policyIds.forEach((policyId) => {
		const policy = store.state.ProposalContext.proposalSteps.get(policyId);

		const fields = policy.inputFields;
		const termination = getFieldValue(fields, POLICY_FIELDS.cancelExistingPolicy, true) === 'true'
			? {
					previous_company_id: getFieldValue(fields, POLICY_FIELDS.previous_company_id),
					previous_policy_id: getFieldValue(fields, POLICY_FIELDS.previous_policy_id),
					termination_option: getFieldValue(fields, POLICY_FIELDS.termination_option),
			  }
			: null;

		const paymentMethod = getFieldValue(fields, POLICY_FIELDS.payment_method) as 'FI_PRÆM' | 'PBS';
		
		
		
		
		// payment Null if FI_præm eller PBS på on load
		const payment: Payment = {
			payment_method: paymentMethod,
			payment_frequency: parseInt(getFieldValue(fields, POLICY_FIELDS.payment_frequency)) as 1 | 12,
			payment_account: null,
		};

		if(paymentMethod === 'PBS' && getFieldValue(fields, POLICY_FIELDS.reg_no))
			payment.payment_account = {
				reg_no: parseInt( getFieldValue(fields, POLICY_FIELDS.reg_no)),
				account: parseInt(getFieldValue(fields, POLICY_FIELDS.account))
			}

		const policyResponse: Policy = {
			id: policyId,
			cover_start_date: getFieldValueDate(fields, POLICY_FIELDS.cover_start_date),
			update_insurance_object: {
				insurance_type: policy.originalType.toUpperCase(),
				...getSubmitToApiInsuranceFields(policy.inputFields),
			},
			termination,
			...payment
		};
		policies.push(policyResponse);
	});
	return policies;
	
};

const getFieldValue = (fields: Array<any>, fieldId: string, ignoreSubmitToApi: boolean = false) => {
	return fields.find((field) => (ignoreSubmitToApi || field.submitToApi) && field.id === fieldId)?.value;
};


const getFieldValueDate = (fields: Array<any>, fieldId: string) => {
	return formatDateString(fields.find((field) => field.submitToApi && field.id === fieldId)?.value, false);
};

const getSubmitToApiInsuranceFields = (inputFields: Array<CmsField>) => {
	const result = {};
	inputFields.forEach((field) => {
		if (field.submitToApi && !ignoreFieldsInUpdateInsuranceObject.includes(field.id)) {
			if(field.value) {
				result[field.id] = getFieldTypeValueFormatted(field);
			}
		}
	});
	return result;
};

const getFieldTypeValueFormatted = (field: CmsField) => {
	if (!field.value) {
		return;
	}
	switch (field.contentType) {
		case INPUT_TYPES.TextField:
			return field.type === 'number' ? parseInt(field.value as string) : field.value;
		case INPUT_TYPES.DatePickerField:
			return formatDateString(field.value as string, false);
		default:
			return field.value;
	}
};
